import React from 'react';

import Grid from '@material-ui/core/Grid';

import { LOGO_IMG } from '@constants';

export default function ({ isResetPass }) {
  return (
    <Grid
      className="logo-header"
      container
      justify="center"
      style={{ paddingTop: isResetPass && '20px' }}
    >
      <img src={LOGO_IMG} alt="logo de la empresa" />
    </Grid>
  );
}
